'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var GETTING_STARTED_GROUP_KEY_OVERRIDE = exports.GETTING_STARTED_GROUP_KEY_OVERRIDE = 'GETTING_STARTED_GROUP_KEY_OVERRIDE';
var GETTING_STARTED_EXPERIENCED = exports.GETTING_STARTED_EXPERIENCED = 'experienced';
var HAS_USED_HUBSPOT = exports.HAS_USED_HUBSPOT = 'has_used_hubspot';
var PRESIGNUP_DEMO_TOUR_GROUP_KEY = exports.PRESIGNUP_DEMO_TOUR_GROUP_KEY = 'GrowthOnboarding:PRESIGNUP_DEMO_TOUR_GROUP_KEY';
var PRESIGNUP_DEMO_TOUR_EXPERIMENT_VERSION = exports.PRESIGNUP_DEMO_TOUR_EXPERIMENT_VERSION = 'GrowthOnboarding:PRESIGNUP_DEMO_TOUR_EXPERIMENT_VERSION';
var EXPERIENCED_SALES_LEADER = exports.EXPERIENCED_SALES_LEADER = 'experienced_sales_leader';